import * as React from "react";
import { useCallback } from "react";
import { MobileOnly } from "../util/mobileOnly";
import { PatientChartAgeGenderMobile } from "./patientChartAgeGenderMobile";
import { AgentRoute } from "../util/agentRoutes";
import { DesktopOnly } from "../util/desktopOnly";
import { PatientCaseWidget } from "./patientCaseWidget";
import { usePatientCase } from "../usePatientCase";
import { useRouteHelper } from "../useRouteHelper";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientChartAgeGenderProps {
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientChartAgeGender = React.memo(
  ({ ...props }: PatientChartAgeGenderProps) => {
    const { patientCase } = usePatientCase();
    const { navigateTo } = useRouteHelper();

    const gotToAgeGender = useCallback(
      () => navigateTo({ route: AgentRoute.AgeAndGender }),
      [navigateTo],
    );

    const gToChiefComplaint = useCallback(
      () => navigateTo({ route: AgentRoute.ChiefComplaint }),
      [navigateTo],
    );

    return (
      <>
        <MobileOnly>
          <PatientChartAgeGenderMobile
            patientCase={patientCase}
            onEditAge={gotToAgeGender}
            onEditChiefComplaint={gToChiefComplaint}
            onEditGender={gotToAgeGender}
          />
        </MobileOnly>

        <DesktopOnly>
          <PatientCaseWidget
            patientCase={patientCase}
            onEditGender={gotToAgeGender}
            onEditAge={gotToAgeGender}
            onEditChiefComplaint={gToChiefComplaint}
          />
        </DesktopOnly>
      </>
    );
  },
);
